import { useQuery } from "@tanstack/react-query";
import api from "../../../api";
import { mieterstromInvoicingApi } from "../../../api/subApis/mieterstromInvoicingApi";
import type {
  ContractFormOptions,
  ContractFormOptionsResponse
} from "../../DeliveryOverview/ContractDeliveries/ContractModal/ContractModal.types";

export function useContractFormOptions(projectId: string) {
  const { isLoading, error, data } = useQuery({
    queryKey: mieterstromInvoicingApi.contractFormOptions.key(projectId),
    queryFn: () => fetchContractFormOptions(projectId)
  });

  return {
    isLoading,
    error,
    data
  };
}

async function fetchContractFormOptions(projectId: string) {
  const endpointUrl =
    mieterstromInvoicingApi.contractFormOptions.url(projectId);
  const response = await api.get<ContractFormOptionsResponse>(endpointUrl);

  const options: ContractFormOptions = {
    supplier: response.data.suppliers.map((supplier) => ({
      value: supplier.id,
      label: supplier.name
    })),
    supplied: response.data.supplied.map((supplied) => ({
      value: supplied.id,
      label: supplied.name
    }))
  };

  return options;
}
